import { ReactNode } from 'react';
import AppHeader from './AppHeader';
import NavMenu from './NavMenu';
import { useReadOnArrival } from '../../shell/notifications/useReadOnArrival';

interface AppLayoutProps {
  children: ReactNode;
}

export default function AppLayout({ children }: AppLayoutProps) {
  // A notification's link carries ?n=<id>; whichever page it opens marks it read (fleet staff notifications, N4).
  useReadOnArrival();
  return (
    <div className="app-container">
      <AppHeader />
      <div className="main-content">
        <NavMenu />
        <main className="page-content">
          {children}
        </main>
      </div>
    </div>
  );
}
